/**
 * Footer component that displays a footer section at the bottom of the application.
 */
import React from 'react';
import './FooterStyles.css';

function Footer() {
  return (
    <footer>
      <div className="footer-content">
        <p>&copy; 2025 MedMap Ltd. All rights reserved.</p>

        {/* Added disclaimer */}
        <p className="footer-disclaimer">
          Disclaimer: This site is an educational aid and not a substitute for professional career guidance.
          Information may contain inaccuracies or be incomplete. Always consult a qualified NHS careers advisor
          or appropriate professional before making career decisions.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
